angular.module('mercury.startup')
.controller('ReactCtrl', function() {
  // This controller does nothing but let us detect that we're
  // on a react route in the AngularJS routing functions that
  // allow us to read the name of the controller when we've got
  // an old and new / to and from state transition occurring.
  // I.e. this is a hack, we're using this dummy controller name
  // as a flag to know we're on a React route...
});
